"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.STATE_DELIMITER = '.';



//////////////////
// WEBPACK FOOTER
// ./~/xstate/lib/constants.js
// module id = 1317
// module chunks = 168707334958949